/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./Error.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { cx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { N200 } from '@atlaskit/theme/colors';
import { errorIconColor, errorTitleColor } from './constants';
var styles = {
  errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
  errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
  teamErrorText: "_syaz1wmz _19pku2gc"
};
export var ErrorWrapper = function ErrorWrapper(props) {
  return fg('compiled-migration-profilecard') ? /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.errorWrapper)
  }, props)) : /*#__PURE__*/React.createElement(ErrorWrapperLegacy, {
    "data-testId": props.testId
  }, props.children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var ErrorWrapperLegacy = styled.div({
  textAlign: 'center',
  padding: "var(--ds-space-300, 24px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  color: errorIconColor
});
export var ErrorTitle = function ErrorTitle(props) {
  return fg('compiled-migration-profilecard') ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.errorTitle)
  }, props.children) : /*#__PURE__*/React.createElement(ErrorTitleLegacy, null, props.children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var ErrorTitleLegacy = styled.p({
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  color: errorTitleColor,
  margin: "var(--ds-space-100, 8px)".concat(" 0")
});
export var TeamErrorText = function TeamErrorText(props) {
  return fg('compiled-migration-profilecard') ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.teamErrorText)
  }, props.children) : /*#__PURE__*/React.createElement(TeamErrorTextLegacy, null, props.children);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var TeamErrorTextLegacy = styled.p({
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  marginTop: "var(--ds-space-100, 8px)"
});